export default __webpack_public_path__ + "static/media/trac_10.947cf975.png";